import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import MessageItem from "./MessageItem";

const MessagesList = ({ messages }) => {
    const messagesEndRef = useRef(null);
    const containerRef = useRef(null);

    // Auto-scroll to bottom when new messages arrive
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ 
                behavior: "smooth",
                block: "end"
            });
        }
    }, [messages]);

    return (
        <Box 
            ref={containerRef}
            sx={{ 
                flex: 1,
                overflow: "auto",
                p: 1,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                backgroundColor: "#fafafa",
                '&::-webkit-scrollbar': {
                    width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#c1c1c1',
                    borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: '#a8a8a8',
                },
            }}
        >
            {messages.length === 0 ? (
                <Box sx={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center",
                    height: "100%",
                    color: "text.secondary"
                }}>
                    No messages yet. Start a conversation!
                </Box>
            ) : (
                messages.map((message, index) => (
                    <MessageItem 
                        key={message.id} 
                        message={message}
                        isLastMessage={index === messages.length - 1}
                    />
                ))
            )}
            <div ref={messagesEndRef} />
        </Box>
    );
};

export default MessagesList; 